module.exports = __webpack_public_path__ + "img/hr-pump-east-liquid.9f722ed6.png";